import React from 'react'
import { Container } from '@scentregroup/ui'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import ProductSummary from '../product-summary'
import MoreText from '../../../components/more-text'
import productAddToCart from '../../../helpers/analytics-utils/product-add-to-cart'
import style from './index.module.scss'

const buyNowClick = product => {
  productAddToCart(product, { eventLabel: 'Buy From Brand' })
}

const BLOCKS_TO_DISPLAY = 4

const ProductDescription = ({ product, hasTitleLink }) => (
  <Container type="small" className={style.productDescription}>
    <ProductSummary
      title={product.retailer.name}
      titleLink={
        hasTitleLink
          ? `/products/retailer/${product.retailer.retailerCode}`
          : null
      }
      productName={product.name}
      salePrice={product.isDiscounted ? product.salePrice : null}
      price={product.price}
      classNames={{
        container: style.productSummary,
        text: style.productDetailsText,
        price: style.productDetailsPrice,
      }}
    />
    <MoreText
      text={product.detailedDescription}
      limit={BLOCKS_TO_DISPLAY}
      classNames={{ wrapper: style.moreText }}
    />
    <Link
      className={style.buyButton}
      to={`/products/buy/${product.objectId}`}
      target="_blank"
      rel="nofollow"
      onClick={() => buyNowClick(product)}
    >
      {`Buy from ${product.retailer.name}`}
    </Link>
  </Container>
)

ProductDescription.propTypes = {
  product: PropTypes.object.isRequired,
  hasTitleLink: PropTypes.bool,
}

export default ProductDescription
